export const getDayjsDateFormat = (pref) => {
  switch ((pref || '').toLowerCase()) {
    case 'mm/dd/yyyy':
      return 'MMM D, YYYY';
    case 'dd/mm/yyyy':
      return 'D MMM, YYYY';
    case 'yyyy/mm/dd':
      return 'YYYY MMM D';
    default:
      return 'MMM D, YYYY';
  }
};
